import { SET_USER_CALENDAR_SETTINGS } from "./saveCalendarSettingsAction";


export const setCalendarSettings = (userSettings) => (
    {
        type: SET_USER_CALENDAR_SETTINGS,
        payload: userSettings,
    }
);